import { core } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';

/**
 * Set selected guest in guestList store
 *
 * @returns {Object} A Redux TockApi action.
 */
export function setSelectedGuest(selectedGuest: {
  purchase: core.PastPurchase;
  ticketGroup: core.TicketGroup;
}): BaseTockAction {
  return {
    type: AppConstants.GUEST_LIST_SET_SELECTED_GUEST,
    payload: selectedGuest,
  };
}

export function clearSelectedGuest(): BaseTockAction {
  return {
    type: AppConstants.GUEST_LIST_CLEAR_SELECTED_GUEST,
  };
}
